import { Modal, Typography, Button, MarkedList } from '@frontend/design_system'
import { useEffect, useState } from 'react'
import { cookiesService } from 'utils/cookiesService'
import { REGISTRATION_SUCCESS_MODAL } from 'texts/onboarding'
import { FIRST_LOGIN_COOKIE_KEY } from 'constants/cookies'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import { isOperatorSelector } from 'redux/login/selectors'

export const RegistrationSuccessModal = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const isOperator = useSelector(isOperatorSelector)

  const isFirstLogin = cookiesService.get(FIRST_LOGIN_COOKIE_KEY)

  useEffect(() => {
    if (isFirstLogin && !isOperator) {
      setModalOpen(true)
      cookiesService.remove(FIRST_LOGIN_COOKIE_KEY)
    }
  }, [isFirstLogin])

  const onClose = () => {
    setModalOpen(false)
  }

  return isModalOpen ? (
    <Modal
      position="center-horizontal"
      title={REGISTRATION_SUCCESS_MODAL.TITLE}
      headerSize="large"
      isDelimiter
      dataTestId="registration-success-modal"
    >
      <div className={styles['modal-content']}>
        <div className={styles['modal-content-description']}>
          <Typography name="Button1" color="grey500" Tag="p">
            {REGISTRATION_SUCCESS_MODAL.DESCRIPTION}
          </Typography>
          <MarkedList
            html={REGISTRATION_SUCCESS_MODAL.MENU_ITEMS_LIST}
            typographyNameForHtml="Button1"
            colorForHtml="grey500"
          />
        </div>
        <Button
          label={REGISTRATION_SUCCESS_MODAL.BUTTON}
          size="large"
          onClick={onClose}
          typographyName="Button1"
          dataTestId="registration-success-modal-confirm-button"
        />
      </div>
    </Modal>
  ) : null
}
